import { render } from "./AppRequests.vue?vue&type=template&id=dd5e8bee&scoped=true"
import script from "./AppRequests.vue?vue&type=script&lang=js"
export * from "./AppRequests.vue?vue&type=script&lang=js"

import "./AppRequests.vue?vue&type=style&index=0&id=dd5e8bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5e8bee"]])

export default __exports__